import { useMemo, type JSX } from 'react';
import { Link } from 'react-router';
import { useAuth } from '../auth/context.js';
import { BookReader } from '../books/BookReader.js';
import { demoBook } from '../demo/demo-book.js';
import { useI18n } from '../i18n/context.js';

/**
 * Демо-книга `/demo` (E15-T2).
 *
 * Открыта и гостю: знакомство с продуктом не должно упираться в регистрацию.
 * Читалка — ровно та же, что и у настоящей книги, данные статичные.
 */
export function DemoBookPage(): JSX.Element {
  const { t, locale } = useI18n();
  const { user } = useAuth();
  const book = useMemo(() => demoBook(t, locale), [t, locale]);

  return (
    <>
      {/* The same bar as the public book and the preview: the reader below starts at the card's edge. */}
      <header className="kitup-public-bar kitup-demo-banner">
        <div className="min-w-0">
          <p className="font-semibold">{t.demo.bannerTitle}</p>
          <p className="max-w-prose text-sm text-[var(--kitup-color-muted)]">{t.demo.bannerText}</p>
        </div>
        <div className="flex flex-wrap gap-2">
          {user ? (
            <Link to="/app" className="kitup-primary-button">
              {t.demo.toBooks}
            </Link>
          ) : (
            <>
              <Link to="/register" className="kitup-primary-button">
                {t.demo.start}
              </Link>
              <Link to="/" className="kitup-secondary-button">
                {t.demo.home}
              </Link>
            </>
          )}
        </div>
      </header>
      <main className="kitup-preview-page kitup-preview-page-public">
        <BookReader book={book} />
      </main>
    </>
  );
}
